import { useCallback, useState } from 'react';
import API from '../../../Infrastructure/API';

interface Settings {
  authToken?: string;
}

export default function useMultiFactorAuthenticationSkip({ authToken }: Settings) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fetched, setFetched] = useState(false);

  const skip = useCallback(() => {
    if (!authToken) {
      return;
    }

    setLoading(true);
    setError(false);

    API.multiFactorAuthentication
      .skip({ authToken })
      .then(() => {
        setFetched(true);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [authToken]);

  return {
    skip,
    loading,
    error,
    fetched,
  };
}
